import { render } from "./CadastrarValor.vue?vue&type=template&id=56b7f908&scoped=true"
import script from "./CadastrarValor.vue?vue&type=script&lang=js"
export * from "./CadastrarValor.vue?vue&type=script&lang=js"

import "./CadastrarValor.vue?vue&type=style&index=0&id=56b7f908&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b7f908"]])

export default __exports__